import {
  HyperdxLogger,
  registerLogger,
  SentryLogger,
  ZettaLogger,
} from '@zep/core-logger';
import { ZEPLogger } from '@zep/logger';

import { hyperdxLoggerConfig, Sentry, zettaClient } from './config';

const zettaLogger = new ZettaLogger(zettaClient);

const hyperdxLogger = new HyperdxLogger(hyperdxLoggerConfig);

const sentryLogger = new SentryLogger(Sentry);

const appLogger = new ZEPLogger({
  loggers: [zettaLogger, hyperdxLogger, sentryLogger],
  initialState: {
    zep_service_name: 'auth-app',
    zep_deployment_env: process.env.NEXT_PUBLIC_STAGE,
    deploymentCommitId: process.env.NEXT_PUBLIC_COMMIT_SHA,
  },
});
registerLogger(appLogger);
